import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar";
import SideBar from "../../../components/SideBar";
import CustomDatePicker from "./component/Custom-Datepicker";
import { Table } from "react-bootstrap";
import ExportToExcel from "../../../components/ExportToExcel";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";

const KpiSummary = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("KPI Summary"));
  }, []);

  const [kpiSummaryProjectedData, setKpiSummaryProjectedData] = useState([]);
  const [kpiSummaryActualData, setKpiSummaryActualData] = useState([]);
  const [kpiSummaryDiffernceData, setKpiSummaryDifferenceData] = useState([]);
  const [loading, setLoading] = useState(true);

  const filteredData = kpiSummaryProjectedData?.filter((item) =>
    Object.values(item).some((value) => String(value).toLowerCase())
  );
  useEffect(() => {
    fetchKpiSummary();
  }, []);


  const [apiStatus, setApiStatus] = useState(undefined)

  const fetchKpiSummary = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}rom-report/10?date=2020-02`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        console.log("cleanedData", cleanedData);
        setKpiSummaryProjectedData(cleanedData?.projected);
        setKpiSummaryActualData(cleanedData?.actual);
        setKpiSummaryDifferenceData(cleanedData?.difference);
        // setKpiSummaryData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Employee Cost. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Cost:", error);
    }
  };

  const [selectedMonth, setSelectedMonth] = useState();

  const handleFilter = async () => {
    setApiStatus(undefined)
    try {
      // Format the selected month to "YYYY-MM" format (e.g., "2024-09")
      const formattedMonthYear = moment(selectedMonth).format("YYYY-MM");

      const response = await GetServiceCaller(
        `${API_URL}rom-report/10?date=${formattedMonthYear}`
      );

      setApiStatus(undefined)

      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setKpiSummaryProjectedData(cleanedData?.projected);
        setKpiSummaryActualData(cleanedData?.actual);
        setKpiSummaryDifferenceData(cleanedData?.difference);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Employee Cost. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Cost:", error);
    }
  };

  return (
    <>
      <div className="container-fluid " id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div>
            {/** Filter Section start*/}
            <div>
              <div className="d-flex justify-content-between me-3">
                <div className="d-flex ">
                  <span className="me-2 align-item-center fw-bold text-nowrap">
                    Select Month
                  </span>

                  <CustomDatePicker
                    handleChange={(e) => setSelectedMonth(e?.target?.value)} // Date picker returns the date object
                    value={selectedMonth}
                    name="selectMonth"
                    dateFormat="yyyy-MM"
                    className="form-control"
                    placeholderText="YYYY-MM"
                  />
                </div>

                <div>
                  <button
                    type="button"
                    className="custom-btn"
                    onClick={handleFilter} // Call the filter function with formatted month
                  >
                    Get Data
                  </button>
                </div>
              </div>
            </div>
            {/** Filter Section end*/}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-4">
            <div className="rounded bg-white" id="skill-table-area">
              <div>
                <h2>Projected KPI's</h2>
                <p className="small">
                  For work done in the month of May 2024 taken on June 2024
                </p>
              </div>
              <div>
                <div className="me-1 mb-2 float-end">
                  <ExportToExcel
                    data={kpiSummaryProjectedData}
                    filename="Projected KPI's.csv"
                  />
                </div>
              </div>
              <div className="box-body table-responsive container-fluid px-0">
                <Table bordered striped hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th className="fw-bold">Title</th>
                      <th className="fw-bold">KPI</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiStatus === 200 && kpiSummaryProjectedData != 0 ?
                    kpiSummaryProjectedData?.map((ele, index) => (
                      <tr key={index}>
                        <td
                          className={
                            [
                              "Total Revenue**",
                              "Total Monthly Cost of Employees",
                              "Total Monthly Cost of Sub-Contractors",
                              "Total Monthly Cost of Billable Employees",
                              "Total No. of Employees",
                            ].includes(ele?.RVName)
                              ? "bg-info fw-bold"
                              : "bg-white"
                          }
                        >
                          {ele?.RVName}
                        </td>
                        <td
                          className={
                            [
                              "Total Revenue**",
                              "Total Monthly Cost of Employees",
                              "Total Monthly Cost of Sub-Contractors",
                              "Total Monthly Cost of Billable Employees",
                              "Total No. of Employees",
                            ].includes(ele?.RVName)
                              ? "bg-info fw-bold text-end"
                              : "bg-white text-end"
                          }
                        >
                          {ele?.Revenue ? ele?.Revenue : "-"}
                        </td>
                      </tr>
                    )):apiStatus === 200 && kpiSummaryProjectedData === 0 ? <tr>
                      <td colSpan={2}>No Data Found</td>
                    </tr>: apiStatus=== undefined ?<tr>
                      <td className="text-center" colSpan={2}>
                        <div>
                          <p>
                            <FaSpinner class="spinner"/>
                          </p>
                        </div>
                      </td>
                    </tr>:null}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="rounded bg-white" id="skill-table-area">
              <div>
                <h2>Actual KPI's</h2>
                <p className="small">
                  Invoice made in the month of June 2024 for work done in May
                  2024
                </p>
              </div>
              <div>
                <div className="me-1 mb-2 float-end">
                  <ExportToExcel
                      data={kpiSummaryActualData}
                    filename="Actual KPI's.csv"
                  />
                </div>
              </div>
              <div className="box-body table-responsive container-fluid px-0">
                <Table bordered striped hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <td className="fw-bold">Title</td>
                      <td className="fw-bold">KPI</td>
                    </tr>
                  </thead>
                <tbody>
  {apiStatus === 200 && kpiSummaryActualData.length !== 0 ? (
    kpiSummaryActualData.map((ele, index) => (
      <tr key={index}>
        <td className={[
          "Total Revenue**",
          "Total Monthly Cost of Employees",
          "Total Monthly Cost of Sub-Contractors",
          "Total Monthly Cost of Billable Employees",
          "Total No. of Employees",
        ].includes(ele?.RVName) ? "bg-info fw-bold text-start" : "bg-white text-start"}>
          {ele?.RVName}
        </td>
        <td className={[
          "Total Revenue**",
          "Total Monthly Cost of Employees",
          "Total Monthly Cost of Sub-Contractors",
          "Total Monthly Cost of Billable Employees",
          "Total No. of Employees",
        ].includes(ele?.RVName) ? "bg-info fw-bold text-start" : "bg-white text-start"}>
          {ele?.Revenue || "-"}
        </td>
      </tr>
    ))
  ) : apiStatus === 200 && kpiSummaryActualData.length === 0 ? (
    <tr>
      <td colSpan={2}>No Data Found</td>
    </tr>
  ) : apiStatus === undefined ? (
    <tr>
      <td className="text-center" colSpan={2}>
        <div>
          <p><FaSpinner className="spinner" /></p>
        </div>
      </td>
    </tr>
  ) : null}
</tbody>

                </Table>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="rounded bg-white" id="skill-table-area">
              <div>
                <h2>Difference</h2>
                <p className="small">
                  Difference between Projected and Actual KPI's
                </p>
              </div>
              <div>
                <div className="me-1 mb-2 float-end">
                  <ExportToExcel
                      data={kpiSummaryDiffernceData}
                    filename="Difference between Projected and Actual KPI's.csv"
                  />
                </div>
              </div>
              <div className="box-body table-responsive container-fluid px-0">
                <Table bordered striped hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <td className="fw-bold">Title</td>
                      <td className="fw-bold">KPI</td>
                    </tr>
                  </thead>
                <tbody>
  {apiStatus === 200 && kpiSummaryDiffernceData.length !== 0 ? (
    kpiSummaryDiffernceData.map((ele, index) => (
      <tr key={index}>
        <td className={[
          "Total Revenue**",
          "Total Monthly Cost of Employees",
          "Total Monthly Cost of Sub-Contractors",
          "Total Monthly Cost of Billable Employees",
          "Total No. of Employees",
        ].includes(ele?.RVName) ? "bg-info fw-bold" : "bg-white"}>
          {ele?.RVName}
        </td>
        <td className={[
          "Total Revenue**",
          "Total Monthly Cost of Employees",
          "Total Monthly Cost of Sub-Contractors",
          "Total Monthly Cost of Billable Employees",
          "Total No. of Employees",
        ].includes(ele?.RVName) ? "bg-info fw-bold text-end" : "bg-white text-end"}>
          {ele?.Revenue || "-"}
        </td>
      </tr>
    ))
  ) : apiStatus === 200 && kpiSummaryDiffernceData.length === 0 ? (
    <tr>
      <td colSpan={2}>No Data Found</td>
    </tr>
  ) : apiStatus === undefined ? (
    <tr>
      <td colSpan={2} className="text-center">
        <div>
          <p><FaSpinner className="spinner" /></p>
        </div>
      </td>
    </tr>
  ) : null}
</tbody>

                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KpiSummary;
